import { requireAuth, requireNotAuth } from '@/helpers';

import Confirm from '@/pages/create-error-report/routes/confirm';
import CreateErrorReport from '@/pages/create-error-report/create-error-report';
import Dashboard from '@/pages/dashboard/dashboard';
import ErrorReports from '@/pages/error-reports/error-reports';
import Laundry from '@/pages/laundry/laundry';
import Login from '@/pages/login';
import Messages from '@/pages/messages/messages';
import Measures from '@/pages/measures/measures';
/*import NewPassword from '@/pages/newpassword';*/
import Offers from '@/pages/offers/offers';
import Profile from '@/pages/profile/profile';
import Proxy from '@/pages/proxy';
import Register from '@/pages/register_spar';
import RegistrationInformation from '@/pages/registrationinformation';
import ContractsInvoices from '@/pages/contracts-invoices/contracts-invoices';
/*import ResetPassword from '@/pages/resetpassword';*/
import RowEditor from '@/pages/create-error-report/routes/row-editor';
import Subscriptions from '@/pages/subscriptions/subscriptions';
import Vacancy from '@/pages/vacancy/vacancy';

export default [
  // Denna används av xpand för att skicka en vidare om inlogg krävs
  {
    path: '/proxy',
    component: Proxy,
    beforeEnter: requireAuth,
  },
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    beforeEnter: requireAuth,
  },
  {
    path: '/felanmalan',
    name: 'ErrorReports',
    component: ErrorReports,
    beforeEnter: requireAuth,
    children: [],
  },
  {
    path: '/felanmalan/skapa',
    name: 'CreateErrorReport',
    component: CreateErrorReport,
    children: [
      {
        path: '',
        redirect: '/felanmalan/skapa/rad/1'
      },
      {
        path: 'rad/:rowId',
        component: RowEditor,
        name: 'ErrorReportEditRow',
        beforeEnter: requireAuth,
        props: (route) => {
          return { id: route.params.rowId };
        },
      },
      {
        path: 'skicka/:status',
        beforeEnter: requireAuth,
        name: 'ErrorReportConfirm',
        component: Confirm,
        props: true,
      }
    ],
  },
  {
    path: '/underhall',
    name: 'DwellingStatus',
    component: Measures,
    beforeEnter: requireAuth,
  },
  {
    path: '/tillval',
    name: 'OptionalsStart',
    component: Proxy,
    props: { xpandUrlPath: '/XpandWeb/Internet/Tv/OptionalsStart.aspx', menuId: 'OptionalsStart' },
    beforeEnter: requireAuth,
  },
  {
    path: '/tillval/bestallningar',
    name: 'OptionalsStatus',
    component: Proxy,
    props: {
      xpandUrlPath: '/XpandWeb/Internet/Tv/OptionalsStatus.aspx',
      menuId: 'OptionalsStatus',
    },
    beforeEnter: requireAuth,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/login?logout',
    name: 'Logout',
    component: Login,
  },
  {
    path: '/login/:loginMethod',
    name: 'LoginWithMethod',
    component: Login,
  },
  {
    path: '/proxy',
    name: 'Proxy',
    component: Proxy,
  },
  {
    path: '/avtal-fakturor',
    name: 'AgreementsInvoices',
    component: ContractsInvoices,
    beforeEnter: requireAuth,
  },
  {
    path: '/information',
    name: 'RegistrationInformation',
    component: RegistrationInformation,
  },
  {
    path: '/login/:redirectTo',
    name: 'LoginAndRedirect',
    component: Login,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    beforeEnter: requireNotAuth,
  },
  {
    path: '/objekt/:id',
    name: 'Vacancy',
    component: Vacancy,
  },
  {
    path: '/bevakningar',
    name: 'Subscriptions',
    component: Subscriptions,
    beforeEnter: requireAuth,
  },
  {
    path: '/tvattstugan',
    name: 'Laundry',
    component: Laundry,
    beforeEnter: requireAuth,
  },
  {
    path: '/profil',
    name: 'Profile',
    component: Profile,
    beforeEnter: requireAuth,
  },
  {
    path: '/erbjudanden',
    name: 'Offers',
    component: Offers,
    beforeEnter: requireAuth,
  },
  {
    path: '/erbjudanden/objekt/:id',
    name: 'OfferVacancy',
    component: Vacancy,
    beforeEnter: requireAuth,
  },
  {
    path: '/intresseanmalan/objekt/:id',
    name: 'NoteOfInterestVacancy',
    component: Vacancy,
    beforeEnter: requireAuth,
  },
  // {
  //   path: '/erbjudande/:id',
  //   name: 'SingleOffer',
  //   component: Offer,
  //   beforeEnter: requireAuth,
  // },
  {
    path: '/sok/:type?',
    name: 'Search',
    component: Vacancy,
  },
  {
    path: '/meddelanden',
    name: 'Messages',
    component: Messages,
    beforeEnter: requireAuth,
  },
];
